<template>
  <div>
    <v-breadcrumbs :items="crumbs"></v-breadcrumbs>
    <!-- <base-loader :isLoading="isLoading"></base-loader> -->
    <v-row>
      <v-col md="6">
        <v-card>
          <v-card-text>
            <h4 class="text-md-h4 primary--text mb-5">
              {{ `${isEdit ? "Edit" : "New"} Lead Source` }}
            </h4>
            <v-form ref="legalEntityForm" @submit.prevent="save()">
              <v-row>
                <v-col md="12">
                  <v-text-field
                    v-model="legalModel.name"
                    label="Lead Source Name"
                    required
                    outlined
                    :rules="[(v) => !!v || 'Lead Source Name is required']"
                  ></v-text-field>
                </v-col>
                <v-col md="12"> </v-col>
              </v-row>
              <v-btn type="submit" color="success">Save</v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { gql } from "apollo-boost";
import { Legal } from "@/models/Legal";
export default {
  name: "EditLegal",
  data() {
    return {
      isEdit: false,
      isLoading: false,
      legalModel: new Legal(),
      me: "",
      search: null,
    };
  },
  created() {
    this.isEdit = this.$route.params.id != 0;
    this.isLoading = this.isEdit ? true : false;
  },
  computed: {
    crumbs() {
      return [
        {
          text: "Lead Sources",
          disabled: false,
          href: "/admin/legal",
        },
        {
          text: "Lead Source Detail",
          disabled: false,
          href: `/admin/legal/${this.$route.params.id}`,
        },
        {
          text: `${this.isEdit ? "Edit" : "New"} Lead Source`,
          disabled: true,
        },
      ];
    },
  },
  watch: {
    // "legalModel.profilePicture": async function(newValue, oldValue) {
    //   var profilePictureAsDataURL = await this.getFileAsDataURL(newValue);
    //   this.profilePictureAsDataURL = profilePictureAsDataURL;
    // },
  },
  apollo: {
    me: gql`
      query {
        me {
          id
        }
      }
    `,
    legalEntity: {
      query: gql`
        query LegalEntity($id: ID!) {
          legalEntity(id: $id) {
            id
            name
          }
        }
      `,
      fetchPolicy: "network-only",
      skip() {
        return !this.isEdit;
      },
      variables() {
        const self = this;
        return {
          id: self.$route.params.id,
        };
      },
      result(response, key) {
        this.isLoading = false;
        this.legalModel.id = this.legalEntity.id;
        this.legalModel.name = this.legalEntity.name;
        // this.legalModel.profilePicture = this.referral.profilePicture;
      },
    },
  },
  methods: {
    async save() {
      this.isLoading = true;
      const self = this;
      if (!self.$refs.legalEntityForm.validate()) {
        self.$swal("Error", "Validation failed", "error");
        self.isLoading = false;
        return;
      }
      if (self.isEdit) {
        await this.updateLegalEntity()
          .then(() => {
            this.$swal("Success!", "Lead Source was updated", "success");
          })
          .catch((e) => {
            this.$swal(
              "Error!",
              "asomething went wrong when trying to update the lead source, check data and try again later!",
              "error"
            );
          });
      } else {
        await this.createLegalEntity()
          .then(() => {
            this.$swal("Success!", "Lead Source was created", "success");
            window.location.href = `/admin/legal/${self.legalModel.id}/edit`;
          })
          .catch((e) => {
            this.$swal(
              "Error!",
              `zSomething went wrong when creating the lead source, check data and try again later!`,
              "error"
            );
          });
      }
      this.isLoading = false;
    },
    async updateLegalEntity() {
      const self = this;
      try {
        const response = await self.$apollo.mutate({
          mutation: gql`
            mutation update($legalEntity: LegalEntityUpdateInput!) {
              updateLegalEntity(legalEntity: $legalEntity) {
                id
                updated
              }
            }
          `,
          variables: {
            legalEntity: {
              id: self.legalModel.id,
              name: self.legalModel.name,
            },
          },
        });
        if (!response) {
          throw "Something went wrong when creating the lead source!";
        }
        if (response.errors && response.errors.length > 0) {
          throw response.errors[0];
        }
      } catch (e) {
        throw e.message;
      }
    },
    async createLegalEntity() {
      const self = this;
      try {
        const response = await self.$apollo.mutate({
          mutation: gql`
            mutation createLegalEntity($legalEntity: LegalEntityCreateInput!) {
              createLegalEntity(legalEntity: $legalEntity) {
                id
              }
            }
          `,
          variables: {
            legalEntity: {
              name: self.legalModel.name,
              createdBy: self.me.id,
            },
          },
        });

        if (!response) {
          throw "Something went wrong when creating the Inventory Item!";
        }
        if (response.errors && response.errors.length > 0) {
          throw response.errors[0];
        }
        if (response && response.data.createLegalEntity) {
          self.legalModel.id = response?.data?.createLegalEntity?.id;
        }
      } catch (e) {
        throw e.message;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
